import { type BaseListQueryDto } from '@shared/http/types';

import { mapBaseListQueryToDto } from '@shared/http/utils';

import { type UsersQuery, type UserOrderBy } from '../models';

const ORDER_BY_DTO_MAP: Record<UserOrderBy, string> = {
  name: 'first_name',
  email: 'email',
};

export function mapUsersQueryToDto(query: UsersQuery): BaseListQueryDto {
  return mapBaseListQueryToDto({
    ...query,
    orderBy: query.orderBy ? ORDER_BY_DTO_MAP[query.orderBy] : undefined,
  });
}
